import React, { FC } from 'react';
import { Row, Col } from 'antd';
import InputField from 'shared/components/InputField';
import styles from '../../activityDataEntry.module.scss';
import { Scope2DesiredData } from 'models/ActivityDataScope2DesiredData/scope2DesiredData.model';
import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';
import { useFormikContext } from 'formik';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { convertToReadableText } from 'shared/utils/convertToUserReadable';
import { allowOnlyNumbers } from 'shared/utils/convertFormData';

interface LocationBasedFieldsProps {
  handleToolTipOpen: (fieldName?: HelpDeskInputFieldEnum) => () => void;
  isEditView: boolean;
  handleMonthlyModalOpen: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string
  ) => () => void;
  handleSwitch: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string
  ) => () => void;
}

const LocationBasedFields: FC<LocationBasedFieldsProps> = ({
  handleToolTipOpen,
  isEditView,
  handleMonthlyModalOpen,
  handleSwitch,
}) => {
  const { values } = useFormikContext<Scope2DesiredData>();
  return (
    <Row gutter={[24, 40]} className={styles.stationaryFormConatiner}>
      {values?.locationBased?.map((location, index) => {
        return (
          <Col span={12}>
            <div className={styles.fieldContainer}>
              <Col span={values?.locationBased?.[index].isYearly ? 16 : 10}>
                <InputField
                  name={`locationBased.${index}.fuelValue`}
                  placeholderstring={location.getPlaceholder?.() ?? ''}
                  label={location.getPlaceholder?.() ?? ''}
                  info
                  infoClick={handleToolTipOpen(
                    convertToReadableText(
                      location?.fuelName
                    ) as HelpDeskInputFieldEnum
                  )}
                  disabled={
                    !isEditView || !values?.locationBased?.[index].isYearly
                  }
                  onKeyDown={allowOnlyNumbers}
                  isNullable={true}
                />
              </Col>
              {!values?.locationBased?.[index].isYearly && (
                <>
                  <Col span={6}>
                    <p
                      className={styles.viewMonthlyText}
                      onClick={handleMonthlyModalOpen(
                        values?.locationBased?.[index],
                        'locationBased',
                        `locationBased[${index}]`
                      )}>
                      View Monthly data
                    </p>
                  </Col>
                  {isEditView && (
                    <span className={styles.pipeSeperator}> | </span>
                  )}
                </>
              )}
              {isEditView && (
                <Col span={8}>
                  <p
                    className={styles.monthlyText}
                    onClick={handleSwitch(
                      values?.locationBased?.[index],
                      'locationBased',
                      `locationBased[${index}]`
                    )}>
                    {values?.locationBased?.[index].isYearly
                      ? 'Switch to monthly'
                      : 'Switch to annually'}
                  </p>
                </Col>
              )}
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

export default LocationBasedFields;
